import { Header } from "@/components/Layout/Header/Header";
import { LogoutButton } from "@/components/Layout/LogoutButton/LogoutButton";

export const OnboardingHeader = () => (
  <Header>
    <LogoutButton />
  </Header>
);
